<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="lg:max-w-xl lg:px-12">
            <div><FormCreditCard ref="form-credit-card"></FormCreditCard></div>
            <div class="w-full flex pt-6">
                <RedButton customClass="w-64 py-2.5 m-auto"
                    @click="clickSaveCard()">{{lbl.creditCard.btn_addcard}}</RedButton>
            </div>
        </MainPage>
    </div>
</template>

<script>
//helper
import OmiseFunction from '@/helper/facade/OmiseFunction.js';
import CacheHelper from '@/helper/CacheHelper'
import { CacheKey } from '@/helper/StaticValue'
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import FormCreditCard from "../component/FormCreditCard.vue";
import RedButton from "@/components/Button/RedButton.vue";
//service
import BKCart from '@/module/ShoppingCart/service/BKCart.js';
import BKCredit from '../service/BkCardit.js';
//model
import { CreditCardListModel } from '../model/CreditCardListModel.js';
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
export default {
    name: "AddCreditCard",
    mixins: [LocaleMixin,ModalMixin,AuthStatusMixin],
    components: {
        MainPage,
        FormCreditCard,
        RedButton
    },
    data: function() {
        return {
            omisePublicKey: null,
            omiseToken: null
        }
    },
    created: function() {

    },
    mounted: function() {
        
    },
    methods: {
        clickBack: function() {
            this.$router.back();
        },
        clickSaveCard: async function() {
            let formData = this.$refs['form-credit-card'].submitForm();
            if (formData != null) {
                let params = formData.getParams();
                this.modal.loadingModal.show();
                await this.apiGetCartConfig();

                var omiseFunction = new OmiseFunction();
                omiseFunction.init(this.omisePublicKey);
                omiseFunction.getToken(params).then(async (res) => {
                    console.log(res);
                    if (res.object == "error") {
                        this.modal.loadingModal.hide();
                        this.modal.errorModal
                            .clearModal()
                            .setMsg(res.message)
                            .show();
                    } else {
                        this.omiseToken = res.id;
                        if (this.isGuestAccountRegistered) {
                            this.saveCardGuest(res);
                        } else {
                            await this.apiPostCreditCard(formData.isDefault);
                        }
                        
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        },
        saveCardGuest: async function(res) {
            let creditCardList = [];
            let creditCardOmise = new CreditCardListModel();
            creditCardOmise.setValueFormOmise(res);
            creditCardList.push(creditCardOmise);

            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.setCredit, creditCardList);

            this.modal.loadingModal.hide();
            this.$router.back();
        },
        apiGetCartConfig: function() {
            return new Promise((resolve) => {
                BKCart.apiGetCartConfig().subscribe({
                    next: (data) => {
                        //console.log(data.omise_key);
                        this.omisePublicKey = data.omise_key;
                        //this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        },
        apiPostCreditCard: function(isDefault) {
            return new Promise((resolve) => {
                BKCredit.apiPostCreditCard(this.omiseToken,isDefault).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        this.$router.back();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        },
    }
}
</script>

<style>

</style>